document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        initLazyLoad();
    }, 100);
});

window.addEventListener("Pageeditor:insert", function() {
    initLazyLoad();
});

window.addEventListener("Pageeditor:change", function() {
    initLazyLoad();
});


function initLazyLoad() {
    "use strict";
    var lazyImages = [].slice.call(document.querySelectorAll(".lazy-bg"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    // lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;
                    if (lazyImage.getAttribute('data-background')) {
                        lazyImage.style.backgroundImage = 'url(' + lazyImage.getAttribute('data-background') + ')';
                    }
                    lazyImage.classList.remove("lazy-bg");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }
}